/** Имитация сетевой задержки для мок-запросов (как при вызове бэкенда). */
export function mockDelay<T>(data: T): Promise<T> {
  return new Promise<T>((resolve) => setTimeout(() => resolve(data), 200 + Math.random() * 200));
}
